module.exports = __webpack_public_path__ + "assets/458df8c1a0c8e37e89e47bfff3bc6088.png";